/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateProjectRequest,
  EditProjectParams,
  EditProjectRequest,
  GetEditableProjectParams,
  HTTPValidationError,
  ProjectSummaryResponse,
  RequestReviewRequest,
} from './platformapi.schemas';

import cloneProjectMutator from '../custom-axios-instance';
import createProjectMutator from '../custom-axios-instance';
import getEditableProjectMutator from '../custom-axios-instance';
import editProjectMutator from '../custom-axios-instance';
import requestReviewMutator from '../custom-axios-instance';
import getProjectSummaryMutator from '../custom-axios-instance';
import unpublishProjectMutator from '../custom-axios-instance';

/**
 * Clones a project. Only valid for org reps and admins.
 * @summary Clone Project
 */
export const cloneProject = (projectId: number, signal?: AbortSignal) => {
  return cloneProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/clone-project/${projectId}`,
    method: 'POST',
    signal,
  });
};

export const getCloneProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneProject>>,
    TError,
    { projectId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneProject>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationKey = ['cloneProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneProject>>,
    { projectId: number }
  > = (props) => {
    const { projectId } = props ?? {};

    return cloneProject(projectId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneProjectMutationResult = NonNullable<Awaited<ReturnType<typeof cloneProject>>>;

export type CloneProjectMutationError = void | HTTPValidationError;

/**
 * @summary Clone Project
 */
export const useCloneProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cloneProject>>,
      TError,
      { projectId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cloneProject>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationOptions = getCloneProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates one or more projects. Only valid for org reps.
 * @summary Create Project
 */
export const createProject = (createProjectRequest: CreateProjectRequest, signal?: AbortSignal) => {
  return createProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createProjectRequest,
    signal,
  });
};

export const getCreateProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    { data: CreateProjectRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: CreateProjectRequest },
  TContext
> => {
  const mutationKey = ['createProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProject>>,
    { data: CreateProjectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createProject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>;
export type CreateProjectMutationBody = CreateProjectRequest;
export type CreateProjectMutationError = void | HTTPValidationError;

/**
 * @summary Create Project
 */
export const useCreateProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProject>>,
      TError,
      { data: CreateProjectRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: CreateProjectRequest },
  TContext
> => {
  const mutationOptions = getCreateProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetches the details of a project for editing
 * @summary Get Editable Project
 */
export const getEditableProject = (params: GetEditableProjectParams, signal?: AbortSignal) => {
  return getEditableProjectMutator<EditProjectRequest>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/edit`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEditableProjectQueryKey = (params?: GetEditableProjectParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/projects/edit`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEditableProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getEditableProject>>,
  TError = void | HTTPValidationError,
>(
  params: GetEditableProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditableProject>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEditableProjectQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditableProject>>> = ({ signal }) =>
    getEditableProject(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEditableProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEditableProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEditableProject>>
>;
export type GetEditableProjectQueryError = void | HTTPValidationError;

export function useGetEditableProject<
  TData = Awaited<ReturnType<typeof getEditableProject>>,
  TError = void | HTTPValidationError,
>(
  params: GetEditableProjectParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditableProject>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditableProject>>,
          TError,
          Awaited<ReturnType<typeof getEditableProject>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEditableProject<
  TData = Awaited<ReturnType<typeof getEditableProject>>,
  TError = void | HTTPValidationError,
>(
  params: GetEditableProjectParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEditableProject>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditableProject>>,
          TError,
          Awaited<ReturnType<typeof getEditableProject>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEditableProject<
  TData = Awaited<ReturnType<typeof getEditableProject>>,
  TError = void | HTTPValidationError,
>(
  params: GetEditableProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditableProject>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Editable Project
 */

export function useGetEditableProject<
  TData = Awaited<ReturnType<typeof getEditableProject>>,
  TError = void | HTTPValidationError,
>(
  params: GetEditableProjectParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEditableProject>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEditableProjectQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edits a project. Only valid for org reps and admins.
 * @summary Edit Project
 */
export const editProject = (
  editProjectRequest: EditProjectRequest,
  params: EditProjectParams,
  signal?: AbortSignal,
) => {
  return editProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/edit`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: editProjectRequest,
    params,
    signal,
  });
};

export const getEditProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editProject>>,
    TError,
    { data: EditProjectRequest; params: EditProjectParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editProject>>,
  TError,
  { data: EditProjectRequest; params: EditProjectParams },
  TContext
> => {
  const mutationKey = ['editProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editProject>>,
    { data: EditProjectRequest; params: EditProjectParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return editProject(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditProjectMutationResult = NonNullable<Awaited<ReturnType<typeof editProject>>>;
export type EditProjectMutationBody = EditProjectRequest;
export type EditProjectMutationError = void | HTTPValidationError;

/**
 * @summary Edit Project
 */
export const useEditProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof editProject>>,
      TError,
      { data: EditProjectRequest; params: EditProjectParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof editProject>>,
  TError,
  { data: EditProjectRequest; params: EditProjectParams },
  TContext
> => {
  const mutationOptions = getEditProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Endpoint to request review of a project.
 * @summary Request Review
 */
export const requestReview = (requestReviewRequest: RequestReviewRequest, signal?: AbortSignal) => {
  return requestReviewMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/request-review`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestReviewRequest,
    signal,
  });
};

export const getRequestReviewMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestReview>>,
    TError,
    { data: RequestReviewRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestReview>>,
  TError,
  { data: RequestReviewRequest },
  TContext
> => {
  const mutationKey = ['requestReview'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestReview>>,
    { data: RequestReviewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return requestReview(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestReviewMutationResult = NonNullable<Awaited<ReturnType<typeof requestReview>>>;
export type RequestReviewMutationBody = RequestReviewRequest;
export type RequestReviewMutationError = void | HTTPValidationError;

/**
 * @summary Request Review
 */
export const useRequestReview = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestReview>>,
      TError,
      { data: RequestReviewRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestReview>>,
  TError,
  { data: RequestReviewRequest },
  TContext
> => {
  const mutationOptions = getRequestReviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetches a summary of a project, including its name and the organization it belongs to.
 * @summary Get Project Summary
 */
export const getProjectSummary = (projectId: number, signal?: AbortSignal) => {
  return getProjectSummaryMutator<ProjectSummaryResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/summary/${projectId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectSummaryQueryKey = (projectId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/projects/summary/${projectId}`] as const;
};

export const getGetProjectSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectSummary>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectSummary>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectSummaryQueryKey(projectId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectSummary>>> = ({ signal }) =>
    getProjectSummary(projectId, signal);

  return { queryKey, queryFn, enabled: !!projectId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProjectSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectSummary>>
>;
export type GetProjectSummaryQueryError = void | HTTPValidationError;

export function useGetProjectSummary<
  TData = Awaited<ReturnType<typeof getProjectSummary>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectSummary>>,
          TError,
          Awaited<ReturnType<typeof getProjectSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectSummary<
  TData = Awaited<ReturnType<typeof getProjectSummary>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectSummary>>,
          TError,
          Awaited<ReturnType<typeof getProjectSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProjectSummary<
  TData = Awaited<ReturnType<typeof getProjectSummary>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectSummary>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Project Summary
 */

export function useGetProjectSummary<
  TData = Awaited<ReturnType<typeof getProjectSummary>>,
  TError = void | HTTPValidationError,
>(
  projectId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectSummary>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProjectSummaryQueryOptions(projectId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Unpublishes a project, moving it back to DRAFT stage. Only valid for org reps and admins.
 * @summary Unpublish Project
 */
export const unpublishProject = (projectId: number, signal?: AbortSignal) => {
  return unpublishProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/unpublish-project/${projectId}`,
    method: 'POST',
    signal,
  });
};

export const getUnpublishProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unpublishProject>>,
    TError,
    { projectId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unpublishProject>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationKey = ['unpublishProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unpublishProject>>,
    { projectId: number }
  > = (props) => {
    const { projectId } = props ?? {};

    return unpublishProject(projectId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnpublishProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof unpublishProject>>
>;

export type UnpublishProjectMutationError = void | HTTPValidationError;

/**
 * @summary Unpublish Project
 */
export const useUnpublishProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unpublishProject>>,
      TError,
      { projectId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unpublishProject>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationOptions = getUnpublishProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
